/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ResolveAlertsMutationVariables = Types.Exact<{
  input: Types.DisplayAlertBulkResolveInput;
}>;


export type ResolveAlertsMutation = { __typename: 'Mutation', displayAlertBulkResolve: { __typename: 'DisplayAlertBulkResolvePayload', displayAlertIds: Array<string> } };

export type AlertsMenuQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AlertsMenuQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: string, displayAlerts: Array<{ __typename: 'DisplayAlert', id: string, createdAt: any, message: string, displayId: string, customerHandle: string, messageObj?: { __typename: 'DisplayAlertMessageObj', type: string, keys: Array<string>, values: Array<string> } | null }> } };

export type AlertsMenuAccessRequestsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ServiceAdminOrgAccessRequestFilter>;
}>;


export type AlertsMenuAccessRequestsQuery = { __typename: 'Query', organizationAccessRequests: Array<{ __typename: 'ServiceAdminOrgAccessRequestDocument', id: string, requestedDurationMinutes: number, status: Types.ServiceAdminOrgAccessRequestStatus, createdAt: any, accessExpiresAt?: any | null, requestingServiceAdmin?: { __typename: 'ServiceAdminOrgAccessRequestUser', givenName?: string | null, familyName?: string | null, email: string } | null }> };

export type AlertsMenu_AlertFragment = { __typename: 'DisplayAlert', id: string, createdAt: any, message: string, displayId: string, customerHandle: string, messageObj?: { __typename: 'DisplayAlertMessageObj', type: string, keys: Array<string>, values: Array<string> } | null };

export type AlertsMenu_AccessRequestFragment = { __typename: 'ServiceAdminOrgAccessRequestDocument', id: string, requestedDurationMinutes: number, status: Types.ServiceAdminOrgAccessRequestStatus, createdAt: any, accessExpiresAt?: any | null, requestingServiceAdmin?: { __typename: 'ServiceAdminOrgAccessRequestUser', givenName?: string | null, familyName?: string | null, email: string } | null };

export const AlertsMenu_AlertFragmentDoc = gql`
    fragment AlertsMenu_alert on DisplayAlert {
  id
  createdAt
  message
  messageObj {
    type
    keys
    values
  }
  displayId
  customerHandle
}
    `;
export const AlertsMenu_AccessRequestFragmentDoc = gql`
    fragment AlertsMenu_accessRequest on ServiceAdminOrgAccessRequestDocument {
  id
  requestingServiceAdmin {
    givenName
    familyName
    email
  }
  requestedDurationMinutes
  status
  createdAt
  accessExpiresAt
}
    `;
export const ResolveAlertsDocument = gql`
    mutation ResolveAlerts($input: DisplayAlertBulkResolveInput!) {
  displayAlertBulkResolve(input: $input) {
    displayAlertIds
  }
}
    `;
export type ResolveAlertsMutationFn = ApolloReactCommon.MutationFunction<ResolveAlertsMutation, ResolveAlertsMutationVariables>;

/**
 * __useResolveAlertsMutation__
 *
 * To run a mutation, you first call `useResolveAlertsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveAlertsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveAlertsMutation, { data, loading, error }] = useResolveAlertsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveAlertsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveAlertsMutation, ResolveAlertsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResolveAlertsMutation, ResolveAlertsMutationVariables>(ResolveAlertsDocument, options);
      }
export type ResolveAlertsMutationHookResult = ReturnType<typeof useResolveAlertsMutation>;
export type ResolveAlertsMutationResult = ApolloReactCommon.MutationResult<ResolveAlertsMutation>;
export type ResolveAlertsMutationOptions = ApolloReactCommon.BaseMutationOptions<ResolveAlertsMutation, ResolveAlertsMutationVariables>;
export const AlertsMenuDocument = gql`
    query AlertsMenu {
  organization {
    id
    displayAlerts {
      id
      ...AlertsMenu_alert
    }
  }
}
    ${AlertsMenu_AlertFragmentDoc}`;

/**
 * __useAlertsMenuQuery__
 *
 * To run a query within a React component, call `useAlertsMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlertsMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AlertsMenuQuery, AlertsMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AlertsMenuQuery, AlertsMenuQueryVariables>(AlertsMenuDocument, options);
      }
export function useAlertsMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AlertsMenuQuery, AlertsMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AlertsMenuQuery, AlertsMenuQueryVariables>(AlertsMenuDocument, options);
        }
export type AlertsMenuQueryHookResult = ReturnType<typeof useAlertsMenuQuery>;
export type AlertsMenuLazyQueryHookResult = ReturnType<typeof useAlertsMenuLazyQuery>;
export type AlertsMenuQueryResult = ApolloReactCommon.QueryResult<AlertsMenuQuery, AlertsMenuQueryVariables>;
export const AlertsMenuAccessRequestsDocument = gql`
    query AlertsMenuAccessRequests($filter: ServiceAdminOrgAccessRequestFilter) {
  organizationAccessRequests(filter: $filter) {
    id
    ...AlertsMenu_accessRequest
  }
}
    ${AlertsMenu_AccessRequestFragmentDoc}`;

/**
 * __useAlertsMenuAccessRequestsQuery__
 *
 * To run a query within a React component, call `useAlertsMenuAccessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsMenuAccessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsMenuAccessRequestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAlertsMenuAccessRequestsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AlertsMenuAccessRequestsQuery, AlertsMenuAccessRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AlertsMenuAccessRequestsQuery, AlertsMenuAccessRequestsQueryVariables>(AlertsMenuAccessRequestsDocument, options);
      }
export function useAlertsMenuAccessRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AlertsMenuAccessRequestsQuery, AlertsMenuAccessRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AlertsMenuAccessRequestsQuery, AlertsMenuAccessRequestsQueryVariables>(AlertsMenuAccessRequestsDocument, options);
        }
export type AlertsMenuAccessRequestsQueryHookResult = ReturnType<typeof useAlertsMenuAccessRequestsQuery>;
export type AlertsMenuAccessRequestsLazyQueryHookResult = ReturnType<typeof useAlertsMenuAccessRequestsLazyQuery>;
export type AlertsMenuAccessRequestsQueryResult = ApolloReactCommon.QueryResult<AlertsMenuAccessRequestsQuery, AlertsMenuAccessRequestsQueryVariables>;